import { render, staticRenderFns } from "./CreateSalePayment.vue?vue&type=template&id=4ac16d00"
import script from "./CreateSalePayment.vue?vue&type=script&lang=js"
export * from "./CreateSalePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports